(function() {
  let isStickyBarActive = false;
  const loyaltyStickyBar = document.querySelector('.loyalty-sticky-bar')
  const stickyBarToggleButtons = document.querySelectorAll('.sticky-bar-toggle');
  
  console.log(stickyBarToggleButtons);
  
  stickyBarToggleButtons.forEach(function(el) {
    
    el.addEventListener('click', function(e) { 
       console.log('click...')
      
      if(isStickyBarActive) {
        loyaltyStickyBar.classList.remove('--active');
        isStickyBarActive = false;
      } else {
        loyaltyStickyBar.classList.add('--active');
        isStickyBarActive = true;
      }
    });
    
  });
  
})();